// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Caixa_DestroyResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for destroy() — DELETE /caixa/destroy/:id
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Caixa_DestroyResponseDados {
id?: number
deleted?: boolean
}

export type Caixa_DestroyResponse = ApiResponse<Caixa_DestroyResponseDados>;

registerResponseContract('Caixa_DestroyResponse', {
  id:      { type: 'number',  required: false },
  deleted: { type: 'boolean', required: false },
})
